import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './GenericLessonViewer.css';
import { trackAction } from '../../services/activityService';
import { GenericLesson } from '../../services/lessonServiceTypes';
import { User } from '../../services/authService';

interface GenericLessonViewerProps {
  lesson: GenericLesson;
  lessonObjective: string;
  moduleName: string;
  user: User | null;
  lessonContent: {
    markdown: string;
    [key: string]: any;
  };
  imageUrl?: string;
}

const GenericLessonViewer: React.FC<GenericLessonViewerProps> = ({
  lesson,
  lessonObjective,
  moduleName,
  user,
  lessonContent,
  imageUrl
}) => {
  useEffect(() => {
    if (lesson) {
      trackAction(user, 'LESSON_READ', {
        lessonId: lesson.lesson_id,
        title: lesson.lesson_name,
        category: lesson.category,
        module: moduleName,
      });
    }
  }, [lesson, moduleName, user]);

  return (
    <div className="generic-lesson-viewer">
      <div className="generic-lesson-header">
        <h1 className="generic-lesson-title">{lesson.lesson_name}</h1>
        <div className="generic-lesson-objective">{lessonObjective}</div>
      </div>

      {imageUrl && (
        <div className="generic-lesson-image-container">
          <img 
            src={imageUrl} 
            alt={lesson.lesson_name}
            className="generic-lesson-image"
          />
        </div>
      )}

      <div className="generic-lesson-content">
        <ReactMarkdown>
          {lessonContent.markdown}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default GenericLessonViewer;

